"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getYearsArray = function getYearsArray() {
  var yearList = [];

  for (var i = 1899; i <= 2100; i++) {
    yearList.push(i);
  }

  return yearList;
};

var yearList = getYearsArray();

var YearPicker = function YearPicker(_ref) {
  var onYearSelect = _ref.onYearSelect,
      selectedDate = _ref.selectedDate;

  var _useState = (0, _react.useState)(selectedDate ? selectedDate.get("year") : (0, _dayjs["default"])().get("year")),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      yearToFocus = _useState2[0],
      setYearToFocus = _useState2[1];

  (0, _react.useEffect)(function () {
    var _yearToFocusEl$scroll;

    var yearToFocusEl = document.getElementById("year_".concat(yearToFocus));
    yearToFocusEl === null || yearToFocusEl === void 0 ? void 0 : (_yearToFocusEl$scroll = yearToFocusEl.scrollIntoView) === null || _yearToFocusEl$scroll === void 0 ? void 0 : _yearToFocusEl$scroll.call(yearToFocusEl, {
      block: "nearest",
      inline: "start"
    });
    yearToFocusEl === null || yearToFocusEl === void 0 ? void 0 : yearToFocusEl.focus();
  }, [yearToFocus]);

  var handleDayKeyboardEvent = function handleDayKeyboardEvent(event) {
    switch (event.key) {
      case "ArrowUp":
        setYearToFocus(function (prev) {
          return prev > 1899 ? prev - 1 : prev;
        });
        break;

      case "ArrowDown":
        setYearToFocus(function (prev) {
          return prev < 2100 ? prev + 1 : prev;
        });
        break;
    }
  };

  return /*#__PURE__*/_react["default"].createElement(YearPickerContainer, null, yearList.map(function (year) {
    return /*#__PURE__*/_react["default"].createElement(YearPickerButton, {
      "aria-label": year,
      key: year,
      selected: (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.get("year")) === year,
      "aria-selected": (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.get("year")) === year,
      tabIndex: yearToFocus === year ? 0 : -1,
      isCurrentYear: (0, _dayjs["default"])().get("year") === year,
      onKeyDown: function onKeyDown(event) {
        return handleDayKeyboardEvent(event);
      },
      id: "year_".concat(year),
      onClick: function onClick() {
        onYearSelect(year);
      }
    }, year);
  }));
};

var YearPickerContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n  overflow-y: scroll;\n  width: ", ";\n  height: 312px;\n  padding: 0px 8px 8px 8px;\n"])), function (props) {
  return props.theme.dateInput.pickerWidth;
});

var YearPickerButton = _styledComponents["default"].button(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  min-height: 40px;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.75;\n  color: ", ";\n  background-color: transparent;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n\n  ", "\n\n  &:hover {\n    font-weight: 400;\n    font-size: 1.5rem;\n    line-height: 33px;\n    color: ", ";\n    background-color: ", ";\n  }\n  &:focus {\n    font-weight: 400;\n    font-size: 1.5rem;\n    line-height: 33px;\n    color: ", ";\n    outline: ", " solid 2px;\n  }\n  &:active {\n    font-weight: 400;\n    font-size: 1.5rem;\n    line-height: 33px;\n    color: #ffffff;\n    background-color: #4b1c7d !important;\n  }\n"])), function (props) {
  return props.theme.dateInput.pickerYearFontColor;
}, function (props) {
  return props.selected ? "font-weight: 400;\n         font-size: 1.5rem;\n         line-height: 33px;\n         color: ".concat(props.theme.dateInput.pickerSelectedDateColor, " !important;\n         background-color: ").concat(props.theme.dateInput.pickerSelectedDateBackgroundColor, " !important;") : props.isCurrentYear ? "border: 1px solid #cbacec; \n         color: #5f249f;" : "";
}, function (props) {
  return props.theme.dateInput.pickerHoverDateFontColor;
}, function (props) {
  return props.theme.dateInput.pickerHoverDateBackgroundColor;
}, function (props) {
  return props.theme.dateInput.pickerHoverDateFontColor;
}, function (props) {
  return props.theme.dateInput.pickerFocusColor;
});

var _default = /*#__PURE__*/_react["default"].memo(YearPicker);

exports["default"] = _default;